import { Course } from '@/domain/entities/course.entity'
import { queryClient } from '@/providers/libs/query-client'
import { ICourseService } from '@/services/contracts/courses'
import { useMutation } from '@tanstack/react-query'

type UpdateACoursesProps = {
  courseService: ICourseService
  id: number
}

export const useEditRegisteredCourse = ({
  courseService,
  id,
}: UpdateACoursesProps) => {
  const mutation = useMutation({
    mutationKey: ['edit-course', id],
    mutationFn: (course: Course) => courseService.update(course),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list_course_by_student_id'] })
    },
  })

  return { mutation }
}
